module.exports = __webpack_public_path__ + "img/Lobby.4d41b219.png";